function circInOut(t) {
  if ((t *= 2) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1)
  return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1)
}

module.exports = circInOut


//////////////////
// WEBPACK FOOTER
// ./node_modules/eases/circ-in-out.js
// module id = 23
// module chunks = 0